import { AvailableCampaigns, type ThemeConfig } from 'entities/Config'

const getTrackingCampaignId = (themeConfig: ThemeConfig) =>
  themeConfig.id !== AvailableCampaigns.default ? themeConfig.id : 'none'

export default getTrackingCampaignId
